import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '../'
import * as styles from './InstagramCta.module.scss'
import instagramPhone from '../../images/instagram-phone.png'

const InstagramCta = ({ eyelash, title, subTitle, buttonText }) => (
  <div className='container section-spacing'>
    <div className={styles.container}>
      <div className={styles.content}>
        {eyelash && <span className={styles.eyelash}>{eyelash}</span>}
        {title && <h2 className={styles.title}>{title}</h2>}
        {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
        <Link
          to='https://www.instagram.com/herjolfur_ohf'
          className={`btn btn--primary ${styles.button}`}
        >
          {buttonText}
        </Link>
      </div>
      <div className={styles.imageWrapper}>
        <img src={instagramPhone} alt={title || 'Herjólfur á Instagram'} />
      </div>
    </div>
  </div>
)

InstagramCta.propTypes = {
  eyelash: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired
}

export default InstagramCta
